import React from 'react';

import InvoiceConclusion from './InvoiceConclusion';
import InvoiceDetailHeader from './InvoiceDetailHeader';
import InvoiceDetailTable from './InvoiceDetailTable';
import PaymentConclusion from './PaymentConclusion';
import PaymentDetail from './PaymentDetail';
import { IInvoicePaymentProps } from './types';

const InvoiceDetail: React.FC<IInvoicePaymentProps> = (props) => (
  <>
    {/* {loading && <CircularProgress />} */}
    {/* {!loading && ( */}
    <div className='invoice-detail-container'>
      <div className='invoice-header'>
        <InvoiceDetailHeader {...props} />
      </div>
      <div className='invoice-detail-table'>
        <InvoiceDetailTable {...props} />
      </div>
      <div className='invoice-conclusion'>
        <InvoiceConclusion {...props} />
      </div>
      <div className='payment-detail-table'>
        <PaymentDetail {...props} />
      </div>
      <div className='invoice-conclusion'>
        <PaymentConclusion {...props} />
      </div>
    </div>
    {/* )} */}
  </>
);

export default React.memo(InvoiceDetail);
